export default __webpack_public_path__ + "static/media/4_Meritxell Pérez_179x177.c1d04413.webp";